import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = { handlerClass: String }

  connect () {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: '.handle',
      onEnd: this.reorder.bind(this),
    });
  }

  reorder (event) {
    const selects = event.item.parentElement.children;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < selects.length; i++) {
      selects[i].querySelector(this.handlerClassValue).value = i;
    }
  }
}
